import useCalculateToDouble from "./use-calculate-to-double";

export default function useLoanAmountCalculator(apr: number, monthlyRepayment: number, months: number): number {
  const monthlyRate: number = useCalculateToDouble(apr);
  const pow: number = Math.pow(monthlyRate + 1, months);
  const loanAmount: number = monthlyRepayment * (1 / monthlyRate - 1 / (monthlyRate * pow));

  return Math.ceil(loanAmount * 100.0) / 100.0;
}
